import React, { useState } from "react";
import Input from "../../../../components/UI/input/GgInput";
import { FAQBlock, IContent, IPMBlock } from "../../../../models/IPages";
import { AddIcon } from "../../../../assets/icons";
import Button from "../../../../components/UI/button/GgButton";
import { Editor } from "../../../../components/UI/editor/QuillEditor";

function FaqBlock({ data, setData, scrollToBottom, CreateNewFAQ, actionData }: IPMBlock) {
  const [faqCount, setFaqCount] = useState(1);

  const ContentBlockHandler = (val: string, type: any, index: number) => {
    setData((prev: any) => {
      const desc = prev?.description
      desc[index][type] = val;
      return { ...prev, description: desc };
    });
  };

  const removeFAQ = (indexToRemove: number) => {
    setData((prev: any) => {
      const newData = { ...prev };
      newData?.description?.splice(indexToRemove, 1);
      return newData;
    });
  };

  return (
    <>
      <div className="title">FAQ Block</div>
      <div className="step-list">
        <div className="step-item">
          <div className="inputs-container">
            <Input
              type="text"
              placeholder="Enter title"
              label="Title"
              value={data?.title}
              onChange={(val) => setData({ ...data, title: val })}
              disabled={!actionData?.edit}
            />
          </div>
        </div>
        <div className="step-item">
          <div className="inputs-container">
            <Input
              type="text"
              placeholder="Enter Subtitle"
              label="Title"
              value={data?.subtitle}
              onChange={(val) => setData({ ...data, subtitle: val })}
              disabled={!actionData?.edit}
            />
          </div>
        </div>
      </div>
      <div className="step-list">
        <div className="step-item title">FAQ Question</div>
      </div>
      {data?.description?.map((faq: FAQBlock, index: number) => (
        <div className="step-list col" key={index}>
          <div className="step-item">
            <div className="step-item" style={{ "display": "flex", "flexDirection": "row" }}>
              <div className="" style={{ "marginTop": "0.8rem" }}>
                Question {index + 1}
              </div>
              <div className="">
                {actionData?.delete ? (
                  <Button
                  label="Remove"
                  stylesType="delete"
                  onPress={() => removeFAQ(index)}
                  style={{ padding: "4px", marginTop: "0.5rem" }}
                />
                ): ""}
              </div>
            </div>
            <div className="inputs-container">
              <Input
                type="text"
                placeholder="Enter your Question"
                value={faq?.heading}
                onChange={(val) =>
                  ContentBlockHandler(val, "heading", index)
                }
                disabled={!actionData?.edit}
              />
            </div>
          </div>
          <div className="step-item ">
            <div className="step-item">Answer</div>
            <Editor
              value={faq?.content}
              onChange={(val) =>
                ContentBlockHandler(val, `content`, index)
              }
              placeholder="Enter Content"
              style={{
                height: "15vh",
                marginBottom: "3rem",
              }}
              readOnly={!actionData?.add && !actionData?.edit}
              />
          </div>
        </div>
      ))}
    </>
  );
}

export default FaqBlock;
